import styled from 'styled-components'

export const HeaderElem = styled.header`
  position: relative;
  height: 180px;
  display: flex;
  align-items: center;
`

export const HeaderLogo = styled.img`
  width: 240px;
`
